var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100.36165%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6633",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.167615%",
    y1: "50%",
    x2: "-0.192983317%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "48.5247558%",
    fx: "50%",
    fy: "48.5247558%",
    r: "562.817647%",
    gradientTransform: "translate(0.500000,0.485248),scale(0.089005,1.000000),translate(-0.500000,-0.485248)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,68.1 L4.5,68.1 C8,68.1 10.3,70.3 10.3,73.5 C10.3,76.7 8,78.9 4.5,78.9 L0,78.9 L0,68.1 Z M4.4,77.5 C7,77.5 8.8,75.9 8.8,73.4 C8.8,71.1 7,69.3 4.4,69.3 L1.5,69.3 L1.5,77.3 L4.4,77.3 L4.4,77.5 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "12.7 68.1 14.2 68.1 14.2 78.7 12.7 78.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "26.6 68.1 26.6 78.7 25.3 78.7 18.9 70.7 18.9 78.7 17.4 78.7 17.4 68.1 18.7 68.1 25.1 76.1 25.1 68.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,73.4 L38.7,73.4 L38.7,77.6 C37.7,78.5 36.2,78.9 34.6,78.9 C31.2,78.9 28.9,76.6 28.9,73.4 C28.9,70.2 31.4,67.9 34.6,67.9 C36.4,67.9 37.7,68.5 38.7,69.5 L37.8,70.7 C36.9,69.8 35.9,69.5 34.7,69.5 C32.2,69.5 30.5,71.3 30.5,73.6 C30.5,75.9 32.3,77.7 34.7,77.7 C35.6,77.7 36.5,77.6 37.2,77 L37.2,73.4 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,68.1 L46.1,68.1 C49.5,68.1 51.8,70.3 51.8,73.5 C51.8,76.6 49.5,78.9 46.1,78.9 L41.9,78.9 L41.9,68.1 Z M46.1,78.2 C49.2,78.2 51.1,76.3 51.1,73.5 C51.1,70.7 49.2,68.8 46.1,68.8 L42.7,68.8 L42.7,78.1 C42.7,78.2 46.1,78.2 46.1,78.2 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4,73.5 C53.4,70.4 55.7,68.1 58.9,68.1 C62.1,68.1 64.4,70.4 64.4,73.5 C64.4,76.6 62.1,78.9 58.9,78.9 C55.9,78.9 53.4,76.6 53.4,73.5 Z M63.8,73.5 C63.8,70.7 61.8,68.8 59,68.8 C56.2,68.8 54.2,70.8 54.2,73.5 C54.2,76.3 56.2,78.2 59,78.2 C61.7,78.2 63.8,76.2 63.8,73.5 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "76 68.1 76 78.7 75.4 78.7 68.1 69.4 68.1 78.7 67.4 78.7 67.4 68.1 68.1 68.1 75.4 77.4 75.4 68.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,73.5 L88.1,73.5 L88.1,77.4 C87.1,78.3 85.8,78.7 84.3,78.7 C81.1,78.7 78.8,76.4 78.8,73.3 C78.8,70.2 81.1,67.9 84.3,67.9 C85.9,67.9 87.2,68.3 88.1,69.4 L87.7,70 C86.8,69.1 85.7,68.7 84.3,68.7 C81.5,68.7 79.5,70.7 79.5,73.4 C79.5,76 81.5,78.1 84.3,78.1 C85.5,78.1 86.5,77.8 87.4,77.1 C87.4,77.1 87.4,73.5 87.4,73.5 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "100.5 68.1 100.5 78.7 99.2 78.7 92.8 70.7 92.8 78.7 91.3 78.7 91.3 68.1 92.6 68.1 99 76.1 99 68.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,73.5 C102.9,70.4 105.4,68 108.6,68 C111.8,68 114.3,70.3 114.3,73.5 C114.3,76.7 111.8,79 108.6,79 C105.2,78.9 102.9,76.6 102.9,73.5 Z M112.6,73.5 C112.6,71.2 110.8,69.4 108.5,69.4 C106.2,69.4 104.3,71.2 104.3,73.5 C104.3,75.8 106.1,77.6 108.5,77.6 C110.9,77.6 112.6,75.9 112.6,73.5 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "131.3 68.1 127.8 78.7 126.2 78.7 123.3 70.1 120.4 78.7 118.8 78.7 115.2 68.1 116.8 68.1 119.7 76.9 122.8 68.1 124.3 68.1 127.2 76.9 130.1 68.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(44.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3,0 C15.1,0 10.1,1.5 6,4.1 C12.6,5.1 19.3,6.3 25.8,7.3 C27.3,7.6 27.8,7.9 27.8,8.6 C27.8,14.1 27.9,19.7 27.8,25.2 C27.5,31.9 28.1,38.8 27.8,45.5 C27.8,46.5 26.6,47.1 24.9,47.3 C18.8,48.3 12.6,49.2 6.5,50.1 C10.6,52.4 15.3,53.9 20.2,53.9 C35.1,53.9 47.2,41.8 47.2,26.9 C47.2,12 35.4,0 20.3,0 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7,42.7 C22.8,37 22.6,31.2 22.7,25.5 C22.8,20.8 22.7,16 22.7,11.3 C22.7,10.7 22.4,10.3 21.7,10.1 C16.7,8.9 11.9,7.6 7,6.5 C5.5,6.1 3.9,5.8 2.5,5.5 C2.2,5.5 1.9,5.5 1.6,5.5 L1.6,5.4 C1,5.3 0.6,5.3 0.1,5.1 L0.1,48.6 C0.5,48.7 1.1,48.7 1.9,49 C2.2,49 2.5,49 2.8,48.9 C5,48.3 7,47.7 9.2,47.3 C13.1,46.3 17.2,45.4 21.2,44.4 C22.1,44.1 22.7,43.6 22.7,42.7 Z M19.9,28 C18.7,28 17.7,27.3 17.7,26.2 C17.7,25.3 18.7,24.4 19.9,24.4 C21.1,24.4 22.1,25.1 22.1,26.2 C22.1,26.8 21.8,27.2 21.2,27.5 C21.2,27.6 21.2,27.6 21.2,27.8 C21.1,27.8 20.9,27.8 20.8,27.7 C20.6,27.9 20.2,28 19.9,28 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-3)",
    cx: 66.1,
    cy: 58.1,
    rx: 38.2,
    ry: 3.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.403cfff904fadac9bd6fe5ce9834f4d5.svg";
export { ForwardRef as ReactComponent };